import { gql } from '@apollo/client';

const surveyQueryFragment = gql`
  fragment SurveyFields on SurveyQuestionChartResult {
    Id
    Question
    Order
    SurveyResults {
      Label
      Order
      Color
      ChartType
      Presentation
      LabelType
      SurveyResultValues {
        Id
        Year
        Value
      }
    }
  }
`;

export default surveyQueryFragment;
